export enum HistoryBooleanFields {
    remote = "Remote"
}